

<div class="season-link-dialog-container">
    <div class="season-link-dialog-header-container">
        <div>  <p class="season-link-dialog-header-text season-link-section-headers">LINK FIELD TO SEASON</p></div>
        <div><p class="season-link-dialog-sub-heading">Are you sure you want to link this field to the selected season?</p></div>
    </div>

    <div class="season-link-btn-dialog-container">
        <button class="cancel-btn" mat-flat-button type="button" (click)="cancel()">
            <div class="cancel-btn-content">
                <span><p class="cancel-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="basic-btn-white-font basic-btn-primary-bg" mat-flat-button type="button" (click)="link()">
            <div class="btn-content">
                <span><p class="btn-text">LINK FIELD</p></span>
            </div>
        </button>
    </div>
</div>





